import styles from "./Line.module.css"

const Line = () => {
    return (
        <div className={styles.line}></div>
    )
}

export default Line